import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';

@Component({
  selector: 'app-reportar-incidente-dialog',
  templateUrl: './reportar-incidente-dialog.component.html',
})
export class ReportarIncidenteDialogComponent {

  motivos: { valor: string; etiqueta: string }[] = [
    { valor: 'PERDIDA', etiqueta: 'Pérdida' },
    { valor: 'ROBO', etiqueta: 'Robo' },
    { valor: 'DANIO', etiqueta: 'Daño' }
  ];

  motivoIncidente: string = '';
  observacion: string = '';
  guardando: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ReportarIncidenteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alert: AlertHelper,
    private entregaEquipoLinkService: EntregaEquipoLinkService
  ) { }

  guardar() {
    if (!this.motivoIncidente) {
      this.alert.error_small('Seleccione el motivo del incidente');
      return;
    }
    this.guardando = true;
    this.entregaEquipoLinkService.registrarIncidente({
      fk_equipoTecnologico: this.data.movimiento.fk_equipoTecnologico,
      fk_trabajador: this.data.movimiento.fk_trabajador || null,
      motivoIncidente: this.motivoIncidente,
      observacion: this.observacion
    }).subscribe({
      next: (res) => {
        this.guardando = false;
        if (res.success) {
          this.alert.success_small(res.msg || 'Incidente registrado');
          this.dialogRef.close(true);
        } else {
          this.alert.error_small(res.msg || 'No se pudo registrar el incidente');
        }
      },
      error: () => { this.guardando = false; }
    });
  }

  cancelar() {
    this.dialogRef.close(false);
  }

}
